import DesignBook from 'shared/components/DesignBook';
import Layout from 'modules/Layout';
import { CheckDashAuth } from './RouteGuard';
import { Navigate } from 'react-router-dom';
import AuthenticationRoutes from './AuthRoutes';
import UserRoutes from './UserRoutes';
import MainRoute from './MainRoutes';
import DashboardRoutes from './DashboardRoutes';
import AIInventoryRoutes from './AIInventoryRoutes';
import RiskManagementRoutes from './RiskManagementRoutes';
import TrainingRoutes from './TrainingRoutes';
import PoliciesRoutes from './PoliciesRoutes';
import ComplianceRoutes from './ComplianceRoutes';
import ManageEmployeeesRoute from './ManageEmployeeesRoute';
import PolicyAcknowledgement from 'modules/policies/policy-management/policy-acknowledgement/Main';
import ManageTeamRoute from './ManageTeamRoutes';
import PreviewTraining from 'modules/training/training-programs/preview-training-program/Main';
import PublicCommandPortal from 'modules/dashboard/public-portal/Main';
import FreshDeskLogin from 'modules/FreshDeskLogin';
import ExternalRiskAssessment from 'modules/risk-management/external-assessments/guest-mode/Main';

const routes = (isUserLoggedIn: boolean, isOrgSelected: boolean): any => [
  {
    path: '',
    element: CheckDashAuth(isUserLoggedIn, isOrgSelected, <Layout />),
    children: [
      {
        path: '',
        element: <Navigate to="/overview" replace />,
      },
      ComplianceRoutes(),
      UserRoutes(),
      DashboardRoutes(),
      AIInventoryRoutes(),
      RiskManagementRoutes(),
      TrainingRoutes(),
      PoliciesRoutes(),
      MainRoute(),
      ManageEmployeeesRoute(),
      ManageTeamRoute(),
    ],
  },
  {
    path: '/policy/acknowledge/:ackId',
    element: <PolicyAcknowledgement />,
  },
  {
    path: '/training-program/assignment/:assignmentId/:trainingId',
    element: <PreviewTraining />,
  },
  {
    path: '/public/submit-ai/:tokenId',
    element: <PublicCommandPortal />,
  },
  {
    path: '/sso/jwt/login',
    element: <FreshDeskLogin />,
  },
  {
    path: '/external-risk-assesment',
    element: <ExternalRiskAssessment />,
  },
  AuthenticationRoutes(isUserLoggedIn),
  { path: '/style', element: <DesignBook /> },
];

export default routes;
